/* Package JSON Import will be here */
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Button } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { changeQuantity, removeAllChangedProductFromOrderReducer } from "reducers/orders";
import { exchangeOrderSummaryChangeQty } from "reducers/exchange/exchangeOrderSummary";
import { ButtonSpinner } from "components/Spinner";
import OrderQtyModal from "components/orders/OrderQtyModal";
import Constants from "utilities/appConstants";
import { checkEligibleForFoc, errorToast } from "utilities/utils";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import { changeFocStatus } from "reducers/common";
/* Project Import will be here */

const ExchangeOrderQtyCounter = (props) => {
    const [isOpenOrderQtyModal, SetIsOpenOrderQtyModal] = useState(false);

    const { orders, cart, appSettings, translate } = useSelector((state) => ({
        orders: state.exchangeOrderSummary,
        cart: state.cart,
        appSettings: state.appSettings,
        translate: getTranslate(state.locale),
    }));

    const dispatch = useDispatch();

    const increment = (e) => {
        e.stopPropagation();

        if (checkForFocValidation) {
            let currentPieceCount = orders.data[props.product.ProductId].count;
            let totalQty = currentPieceCount + (orders.data[props.product.ProductId].case_count * props.product.ConversionQty);
            let count = currentPieceCount;

            /* Check for isEnableMinOrderQty logic */
            if (appSettings.isEnableMinOrderQty && props.product.MinORDQty !== 0) {
                /* If the added count of the product is === 0 then directly add the MinOrderQty value */
                if (totalQty === 0)
                    count = currentPieceCount + props.product.MinORDQty;

                /* Else if check for it should not exceed the MaxOrderQty value */
                else if ((totalQty + 1) > props.product.MaxORDQty && props.product.MaxORDQty !== 0)
                    errorToast({ content: translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });

                /* Else check for RoundOrderQty and assign the value to the product */
                else {
                    if (props.product.MaxORDQty === 0 || ((totalQty + props.product.RoundORDQty) <= props.product.MaxORDQty))
                        count = currentPieceCount + props.product.RoundORDQty;
                    else {
                        errorToast({ content: translate("order.minOrderQty.validationMsg", { count: this.props.product.MaxORDQty }) });
                    }

                }
            }
            /* If isEnableMinOrderQty is set to false do not check any conditions directly increment the count to +1 */
            else
                count = currentPieceCount + 1;

            /* Save updated count */
            changeUpdatedQty(count, false);
        }
    };

    const decrement = (e) => {
        e.stopPropagation();

        if (checkForFocValidation) {
            let count = 0;
            let currentPieceCount = orders.data[props.product.ProductId].count;
            let currentCaseCount = orders.data[props.product.ProductId].case_count * props.product.ConversionQty;
            let totalQty = currentPieceCount - currentCaseCount;

            /* Check for isEnableMinOrderQty logic */
            if (appSettings.isEnableMinOrderQty && props.product.MinORDQty !== 0) {
                if (totalQty === props.product.MinORDQty)
                    count = 0;
                else
                    count = currentPieceCount - props.product.RoundORDQty
            }
            else
                count = currentPieceCount - 1;

            /* Save updated count */
            changeUpdatedQty(count, (count === 0 && currentCaseCount < props.product.MinORDQty) ? true : false);
        }
    };

    /* Save updated count */
    const changeUpdatedQty = (updatedCount, isClearCaseCount) => {
        if (updatedCount >= 0 && updatedCount <= 9999) {
            const requestObject = {
                count: updatedCount,
                id: props.product.ProductId,
                isChanged: true
            };
            if (isClearCaseCount)
                requestObject.case_count = 0;

            if (props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST)
                dispatch(exchangeOrderSummaryChangeQty(requestObject))
            else
                dispatch(changeQuantity(requestObject));
        }
    }

    const checkForFocValidation = () => {
        if (appSettings.isEnableFoc && props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST) {
            if (checkEligibleForFoc(orders, !props.product.IsSaleable)) {
                return true;
            }
            else {
                /* Check for if any products added in the cart */
                if (cart.ids.length <= 0) {
                    /* Ask for clear the added products in the local */
                    modalConfirmationHook(translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
                        translate,
                        (() => {
                            dispatch(removeAllChangedProductFromOrderReducer());
                            dispatch(changeFocStatus(false));
                        }));
                }
                else {
                    errorToast({
                        content: translate("products.foc.focRequestValidation")
                    });
                }
                return false;
            }
        }
        else {
            return true;
        }
    }

    const onQtyChanged = (value) => {
        if (value >= 0 && value <= 9999 && checkForFocValidation) {
            const requestObject = {
                count: Number(value),
                id: props.product.ProductId,
                isChanged: true
            };

            var totalQty = Number(value) + (orders.data[props.product.ProductId].case_count * props.product.ConversionQty);
            if (totalQty < props.product.MinORDQty) {
                requestObject.case_count = 0;
            }

            if (props.pageType === Constants.EXCHANGE_RETURN_PRODUCT_LIST)
                dispatch(exchangeOrderSummaryChangeQty(requestObject))
            else
                dispatch(changeQuantity(requestObject));
        }
    };

    const openOrderQtyModal = () => {
        SetIsOpenOrderQtyModal(true);
    }

    const closeOrderQtyModal = () => {
        SetIsOpenOrderQtyModal(false);
    }

    return (
        <React.Fragment>
            {!orders.isLoading && orders.data[props.product.ProductId] ? (
                <div className="d-flex align-items-center">
                    {props.product.IsFree ? (
                        <div className="product-quantity d-flex align-items-center">
                            <div className="card-quantity-input">
                                <p className="m-auto">{props.product.pieceQTY}</p>
                            </div>
                        </div>
                    ) : (
                        <div className="product-quantity d-flex align-items-center">
                            <Button
                                className={(appSettings.isRestrictSIHProducts && props.product.SIH === 0) ? "product-qul-disabled" : "product-qul"}
                                icon={<i className="icon-minus" />}
                                size="small"
                                onClick={decrement}
                                disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                            />
                            <div className="card-quantity-input">
                                <Button
                                    type="text"
                                    size="small"
                                    onClick={openOrderQtyModal}
                                    disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                                >
                                    {orders.data[props.product.ProductId].count}
                                </Button>
                            </div>
                            <Button
                                className={(appSettings.isRestrictSIHProducts && props.product.SIH === 0) ? "product-qul-disabled" : "product-qul"}
                                icon={<span className="card-plus-sign">+</span>}
                                size="small"
                                onClick={increment}
                                disabled={appSettings.isRestrictSIHProducts && props.product.SIH === 0}
                            />
                        </div>
                    )}
                </div>)
                :
                        <div className="loding-spinner-div">{orders.isLoading && <ButtonSpinner />}</div>
            }

            {isOpenOrderQtyModal &&
                <OrderQtyModal
                    closeOrderQtyModal={closeOrderQtyModal}
                    onQtyChanged={onQtyChanged}
                    isShowOrderQtyModal={isOpenOrderQtyModal}
                    orders={orders}
                    product={props.product}
                    appSettings={appSettings}
                    pageType={Constants.PIECE_QTY}
                />
            }
        </React.Fragment>
    );
}

export default ExchangeOrderQtyCounter;